import { defineComponent } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import RightsUserOverviewCode from '@/presentation/components/rights/rights-users-overview/rights-user-overview.code';

export default defineComponent({
	components: {
		LoadingWrapper
	},
	setup: () => {
		const code = new RightsUserOverviewCode();

		return {
			isLoading: code.isLoading,
			rightsUsers: code.rightsUsers,
			removeRightsUser: code.removeRightsUser.bind(code)
		};
	}
});
